var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDevices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33356 5.41667V17.3333H21.6669V5.41667H4.33356ZM2.16689 4.34092C2.16689 3.73858 2.65981 3.25 3.24156 3.25H22.7589C23.3526 3.25 23.8336 3.73642 23.8336 4.34092V19.5H2.16689V4.34092ZM1.08356 20.5833H24.9169V22.75H1.08356V20.5833Z",
    fill: "#485EB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1664 9.31675C15.1664 8.95776 15.4575 8.66675 15.8164 8.66675H23.1831C23.5421 8.66675 23.8331 8.95776 23.8331 9.31675V22.1001C23.8331 22.4591 23.5421 22.7501 23.1831 22.7501H15.8164C15.4575 22.7501 15.1664 22.4591 15.1664 22.1001V9.31675Z",
    fill: "#EDEFF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7332 9.31665C14.7332 8.41919 15.4607 7.69165 16.3582 7.69165H23.7248C24.6223 7.69165 25.3498 8.41919 25.3498 9.31665V22.1C25.3498 22.9975 24.6223 23.725 23.7248 23.725H16.3582C15.4607 23.725 14.7332 22.9974 14.7332 22.1V9.31665ZM16.6832 9.64165V21.775H23.3998V9.64165H16.6832Z",
    fill: "#485EB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDevices);
export default __webpack_public_path__ + "static/media/icn_devices.b91e2d835e787a4db3f4d1caccef849f.svg";
export { ForwardRef as ReactComponent };